export enum StorageType {
    LocalStorage,
    SessionStorage,
    Cookie
}